import React, { useEffect, useState } from "react";
import API from "utils/API";
import ReactStrapTable from "components/reactStrapTable";
import CellOptions from "components/reactStrapTable/components/CellOptions";
import CellEditRender from "components/reactStrapTable/components/CellEditRender";

let rowForEdit = {};

const LocationTable = ({
  data,
  loading,
  onExport,
  filters,
  totalSize,
  onPageChange,
  coveredEntityID,
  refetch,
  tenantID,
  setLoading,
  onSearchColumnFilters,
  reset,
}) => {
  const [state, updateState] = useState({
    tableData: [],
    backUpData: [],
    filters: filters,
  });
  useEffect(() => {
    setState({ tableData: data, backUpData: data });
  }, [data]);

  const setState = (state) => updateState((pre) => ({ ...pre, ...state }));

  useEffect(() => {
    setState({ filters: filters });
  }, [filters]);

  useEffect(() => {
    setState({
      tableData: [],
      backUpData: [],
    });
    rowForEdit = {};
  }, [reset]);

  const updateRowValue = (value, col) => {
    const tempRow = { ...rowForEdit };
    tempRow[col] = value;
    rowForEdit = tempRow;
  };

  const formatter = (row, col, formatterType, alwaysEditableCheckbox) => {
    return (
      <CellEditRender
        row={row}
        hasEditable={col.edit}
        columnName={col.dataField}
        formatterType={formatterType}
        onChange={updateRowValue}
        alwaysEditableCheckbox={alwaysEditableCheckbox}
      />
    );
  };

  const saveUpdateRow = async () => {
    setLoading(true);
    const payload = { ...rowForEdit };
    payload.eligibleFlag = payload.eligibleFlag === null ? "N" : payload.eligibleFlag;
    delete payload.isEdit;
    try {
      const result = await API.post(
        `/${tenantID}/CEServiceLocation/Update/${coveredEntityID}`,
        payload
      );
      if (result) {
        setLoading(false);
        refetch();
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const editRow = (rowData, isEdit = true) => {
    let tempData = [...data];
    tempData = tempData.map((row) => {
      row.isEdit = false;
      if (row.ceServiceLocationID === rowData?.ceServiceLocationID && isEdit) {
        row.isEdit = isEdit;
        rowForEdit = row;
      }
      return row;
    });
    setState({
      backUpData: tempData,
      tableData: tempData,
    });
  };

  const cellRenderEdit = (row) => {
    return <CellOptions row={row} onEdit={editRow} onSave={saveUpdateRow} />;
  };

  let columns = [
    {
      dataField: "edit",
      text: "Options",
      width: 80,
      short:false,
      show: true,
      disabled: true,
      hideColFilter: true,
      cellRenderer: (row) => cellRenderEdit(row),
      action: true,
    },
    {
      dataField: "serviceLocationName",
      text: "Service Location Name",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col),
      edit: false,
    },
    {
      dataField: "eligibleFlag",
      text: "Eligible Flag",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col, "checkbox"),
      edit: true,
    },
    {
      dataField: "comments",
      text: "Comments",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col, "textarea"),
      edit: true,
    },
    {
      dataField: "source",
      text: "Source",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col),
    },
    {
      dataField: "createdBy",
      text: "Created By",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col),
    },
    {
      dataField: "createdDate",
      text: "Created Date",
      sort: true,
      width: 144,
      show: true,
      inputType: "date",
      cellRenderer: (row, col) => formatter(row, col, "date"),
    },
    {
      dataField: "modifiedBy",
      text: "Modified By",
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      cellRenderer: (row, col) => formatter(row, col),
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: true,
      width: 144,
      show: true,
      inputType: "date",
      cellRenderer: (row, col) => formatter(row, col, "date"),
    },
  ];

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setState({
        filters: filter,
      });
      let colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    setState({
      filters: filter,
    });
    onPageChange(filter);
  };

  const handleFilterCancel = () => {
    refetch(true);
  };

  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
      onSearchColumnFilters(filter);
      setState({
        filters: filter,
      });
    }
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setState({
        filters: filter,
      });
      let colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      setState({
        filters: filter,
      });
      onPageChange(filter);
    }
  };

  const handleSort = (filter, hasColFilter) => {
    setState({
      filters: filter,
    });
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };

  const { filters: colFilter, backUpData } = state;
  return (
    <div className="table-card scroll-table position-relative border-0 rounded pt-0">
      <ReactStrapTable
        id="location-table"
        fixedColumn
        data={backUpData}
        loading={loading}
        columns={columns}
        onPageSizeChange={onPageSizeChange}
        pageSize={colFilter.pageSize}
        onFilterCancel={handleFilterCancel}
        onSearchColumnFilters={handleSearchColumnFilters}
        onExport={onExport}
        hasPagination
        onPageChange={onHandlePageChange}
        currentPage={colFilter.currentPage}
        totalRecords={totalSize}
        filters={colFilter}
        handleSort={handleSort}
      />
    </div>
  );
};

export default LocationTable;
